import * as React from 'react';

import { Routes, Route } from 'react-router-dom';

import RequireAuth from '../../components/RequireAuth';

import { useAppData } from '../../core/context/AppDataContext';
import { ReportType } from '../../core/api/clients';
import { AuthorizedFormDataProvider } from '../../core/context/AuthorizedFormDataContext';

import LoadingOverlay from '../../components/LoadingOverlay';

import SafetyEventHome from './SafetyEventHome';
import SafetyEventFormNew from './SafetyEventFormNew';
import SafetyEventFormLayout from './SafetyEventFormLayout';
import SafetyEventFormEdit from './SafetyEventFormEdit';
import SafetyEventFormView from './SafetyEventFormView';
import SafetyEventAuditLogs from './SafetyEventAuditLogs';
import useTitle from '../../core/api/hooks/common/useTitle';

function SafetyEventContainer() {
  const { authorizedForms, getFormByName } = useAppData();
  useTitle(document.documentURI);
  if (authorizedForms !== undefined) {
    const form = getFormByName(ReportType.SafetyEventReport);

    if (form !== undefined) {
      const { isContributor, isAdministrator, isReader, isApprover } = form;

      const canEdit = isContributor || isApprover || isAdministrator;
      const canView = isReader || canEdit;

      return (
        <AuthorizedFormDataProvider authorizedFormData={form}>
          <Routes>
            <Route path=":formId" element={<SafetyEventFormLayout />}>
              <Route
                path="edit"
                element={(
                  <RequireAuth isAuthorized={canEdit ?? false}>
                    <SafetyEventFormEdit />
                  </RequireAuth>
                )}
              />
              <Route
                path="logs"
                element={(
                  <RequireAuth isAuthorized={canView ?? false}>
                    <SafetyEventAuditLogs />
                  </RequireAuth>
                )}
              />
              <Route
                path=":action"
                element={(
                  <RequireAuth isAuthorized={canView ?? false}>
                    <SafetyEventFormView />
                  </RequireAuth>
                )}
              />
            </Route>
            <Route
              path="new"
              element={(
                <RequireAuth isAuthorized={form.isContributor ?? false}>
                  <SafetyEventFormNew />
                </RequireAuth>
              )}
            />
            <Route index element={<SafetyEventHome />} />
          </Routes>
        </AuthorizedFormDataProvider>
      );
    }

    return <span>Not Authorized</span>;
  }

  return <LoadingOverlay />;
}

export default SafetyEventContainer;
